import { TextToggleButton } from './swatch.styled'
import Typography from '../../atoms/typography'
import { number, oneOfType, string, bool } from 'prop-types'
import { useState } from 'react'

const TextSwatch = ({ label, value, current, onChange, excludeInternalState, ...rest }) => {
	const [selected, setSelected] = useState(current ?? false)

	const handleChange = (event, newValue) => {
		setSelected(!selected)

		if (onChange) {
			onChange(newValue)
		}
	}

	return (
		<TextToggleButton
			aria-label={label}
			value={value}
			selected={excludeInternalState ? current : selected}
			onChange={handleChange}
			{...rest}
		>
			<Typography>{value}</Typography>
		</TextToggleButton>
	)
}

TextSwatch.propTypes = {
	label: string,
	value: oneOfType([number, string]),
	excludeInternalState: bool,
}

export default TextSwatch
